import $ from 'jquery';

import application from 'application/application';

import ResponseStore from 'application/classes/response-store/response-store.class';

const

	replaceURLParams = (value = '', params = {}) => {

		Object.keys(params).forEach(
			current => value = value.replace(
				new RegExp(`:${current}(\\/|$)`, 'g'),
				params[current] + '$1'
			)
		);

		return value;

	};

application

	.service('helper', ['$rootScope', '$timeout', 'API', 'dataCache', function($rootScope, $timeout, API, dataCache) {

		/** @TODO: Descrever. */
		this.http = (custom = {}, method = 'GET', params) => {

			let

				{ protocol, hostname, port, root, version, paths } = { ...API.default, ...custom },

				host = hostname + (port ? `:${port}` : ''),

				origin = `${protocol}//${host}`,

				href = origin + (root ? `/${root}` : '') + `/${paths[method]}`;

			params = {
				version,
				...params
			};

			return {
				method: /^(?:GET|POST|PUT|DELETE)$/.test(method) ? method : 'GET',
				url: replaceURLParams(href, params)
			};

		};

		/** @TODO: Descrever. */
		this.httpFields = fields => {

			let

				response = { campos: fields.join(',') },

				expand = fields.filter(value => /^\w+(?:\.\w+)+$/.test(value)).map(value => value.replace(/\.\w+$/, '')).filter((value, index, array) => array.indexOf(value) === index);

			if (expand.length)

				response.expansao = expand.join(',');

			return response;

		};

		/** @TODO: Descrever. */
		this.responseStore = data => new ResponseStore(data);

		/** @TODO: Descrever. */
		this.defer = fn => $timeout(fn);

		/** @TODO: Descrever. */
		this.cloneSimpleObject = object => JSON.parse(JSON.stringify(object));

		/**
		* Distribui os itens de um array de uma dimenssão hierarquicamente mantendo a refereância original.
		*
		* @param {Array} list - Lista de itens a serem reorganizados
		* @param {String} parentProperty - Nome da propriedade que define o item pai.
		* @param {String} childProperty - Nome da propriedade onde o filho deve ser assinado.
		* @param {String} trackBy - Nome da propriedade à ser comparada para encontrar o pai.
		* @param {String} filter - Controlar quais itens devem ser mostrados de acordo o filtro.
		*
		* @example
		* makeHierarchical(menus.getItems(), 'parent', 'child', 'id');
		*/
		this.makeHierarchical = (list, parentProperty, childProperty, trackBy, filter = false) => {

			list.forEach(item => {

				if (Array.isArray(item[childProperty]))

					item[childProperty].forEach((child, index) => {

						if (child[parentProperty] !== item[trackBy])

							item[childProperty].splice(index, 1);

					});

			});

			if (filter)

				list.forEach((item, index) => {

					if (!item.showing)

						list.splice(index, 1);

					if (item.children)

						item.children.reduce((children, item, index) => {

							if (!item.showing)

								children.splice(index, 1);

							return children;

						}, item.children);

				});

			list.reduce((accumulator, currentValue) => {

				if (currentValue.hasOwnProperty(parentProperty)) {

					let target = accumulator.find(current => current[trackBy] === currentValue[parentProperty]);

					if (typeof target === 'object') {

						if (Array.isArray(target[childProperty])) {

							if (!target[childProperty].find(value => value[trackBy] === currentValue[trackBy]))

								target[childProperty].push(currentValue);

						} else {

							target[childProperty] = [ currentValue ];

						}

					}

				}

				return accumulator;

			}, list);

			return list.filter(current => !/^\d+$/.test(current[parentProperty]));


		};

		/** @TODO: Descrever. */
		this.removeChildren = (items, responseStore) => {

			items.forEach(itemRemoved => {

				responseStore.getItems().forEach(item => {

					if (item.id == itemRemoved.idMenuPai)

						if (item.children)

							item.children.forEach((children, index) => {

								if (children.id === itemRemoved.id)

									item.children.splice(index, 1);

							});

				});

			});

		};

		/** @TODO: Descrever. */
		this.dataCache = (name, callback) => {

			if (!dataCache.hasOwnProperty(name))

				dataCache[name] = callback();

		};

		/** @TODO: Descrever. */
		this.getDataCache = name => dataCache[name];

		/** @TODO: Descrever. */
		this.deleteDataCache = name => delete dataCache[name];

		/** @TODO: Descrever. */
		this.dismissModal = modal => $(modal ? `#${modal}` : '.modal').modal('hide');

	}]);
